import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import classnames from 'classnames';
import { message, Empty } from 'antd';
import Modal from '@lingxi-common-component/sirius-ui/SiriusModal';
import Radio from '@lingxi-common-component/sirius-ui/Radio';
import { EnhanceSelect, InSingleOption } from '@lingxi-common-component/sirius-ui/Select';
import Cascader from '@lingxi-common-component/sirius-ui/Cascader';
import Tooltip from '@lingxi-common-component/sirius-ui/Tooltip';
import Input from '@lingxi-common-component/sirius-ui/Input';
import { TongyongGuanbiMian } from '@sirius/icons';
import { ReactComponent as TongyongShuomingXian } from '@web-common/images/newIcon/tongyong_shuoming_xian.svg';
import { ProductSettingModal } from '@web-edm/components/productSettingModal/productSettingModal';
import { ReactComponent as AddIcon } from '@/images/icons/website/tongyong_tianjia.svg';
import { ReactComponent as CheckIcon } from '@/images/icons/website/tongyong_chenggong.svg';
import { ReactComponent as CloseIcon } from '@/images/icons/website/tongyong_guanbi.svg';
import { apiHolder, apis, getIn18Text } from 'api';
import style from './style.module.scss';
const systemApi = apiHolder.api.getSystemApi();
import { config } from 'env_def';
import { genSiteLinkButtonHtml } from './genButtonHtml';
const siteApi = apiHolder.api.requireLogicalApi(apis.siteApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const SiteLinkButtonModal = (props) => {
    const { fromPage, btnType, setBtnType, modalTitle, simpleStyle, defaultCurrentBtnData } = props;
    const [submitLoading, setSubmitLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [addBtnName, setAddBtnName] = useState('');
    const btnListRef = useRef(null);
    const [btnList, setBtnList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentBtnData, setCurrentBtnData] = useState(defaultCurrentBtnData);
    const [isSelectSite, setIsSelectSite] = useState(true);
    const [landingPageOptions, setLandingPageOptions] = useState([]);
    const [showSelectProductCount, setShowSelectProductCount] = useState(false);
    const productNameListRef = useRef(null);
    const [selectProductList, setSelectProductList] = useState([]);
    const [cascaderOptions, setCascaderOptions] = useState([]);
    const [selectSite, setSelectSite] = useState(['']);
    const [showSettingProductModal, setShowSettingProductModal] = useState(false);
    const [selectLandingPage, setSelectLandingPage] = useState();
    const handleBtnTypeChange = (value) => {
        setBtnType(value);
        if ((value = 3)) {
            trackApi.track('mail_interact_insert', { from_page: fromPage, action: 'feedback' });
        }
    };
    useEffect(() => {
        setIsSelectSite(true);
    }, [props.visible]);
    const onOk = async () => {
        var _a;
        const businessType = fromPage == 'mail' ? 'NORMAL' : 'MARKETING';
        if (!currentBtnData) {
            message.error('请选择按钮');
            return;
        }
        if (btnType == 1) {
            if (selectProductList.length == 0) {
                message.error('请选择商品');
                return;
            }
            if (cascaderOptions.length > 0 && !(selectSite === null || selectSite === void 0 ? void 0 : selectSite[0])) {
                message.error('请选择站点');
                setIsSelectSite(false);
                return;
            }
        }
        if (btnType == 2) {
            if (!selectLandingPage) {
                message.error('请选择营销落地页');
                return;
            }
        }
        const aptAttrMap = {
            1: 'GEN_PRODUCT_LIST_LINK',
            2: 'GEN_BTN_LANDING_PAGE_LINK',
            3: 'GEN_FEEDBACK_PAGE_LINK',
        };
        const siteId = btnType == 1 ? selectSite[0] : undefined;
        const domain = btnType == 1 ? selectSite[1] : undefined;
        const productIds = btnType == 1 ? selectProductList.map(item => item.id) : undefined;
        setSubmitLoading(true);
        const links = await siteApi.getSiteLinks({
            businessType,
            siteOptAttrType: aptAttrMap[btnType],
            siteId,
            domain,
            productIds,
            pageIds: selectLandingPage ? [selectLandingPage] : undefined,
        });
        if (!links || !((_a = links[0]) === null || _a === void 0 ? void 0 : _a.link)) {
            console.error('数据异常', currentBtnData, links);
            setSubmitLoading(false);
            return;
        }
        const subBusinessTypeMap = {
            1: 'PRODUCT_LIST_PAGE',
            2: 'LANDING_PAGE',
            3: 'FEEDBACK_PAGE',
        };
        const buttonHtml = genSiteLinkButtonHtml(Object.assign(Object.assign({}, currentBtnData), { link: links[0].link, businessType: subBusinessTypeMap[btnType], pageId: btnType == 2 ? selectLandingPage : '' }));
        props.onOk(buttonHtml);
        props.onClose();
        setSubmitLoading(false);
        trackApi.track('mail_interact_insert', { from_page: fromPage, action: 'submit' });
    };
    useLayoutEffect(() => {
        if (btnListRef.current && editing) {
            btnListRef.current.scrollTop = btnListRef.current.scrollHeight;
        }
    }, [editing]);
    const fetchBtnList = async () => {
        setLoading(true);
        const data = await siteApi.edmSiteOptGetBtnList();
        if (Array.isArray(data)) {
            setBtnList(data);
            if (data.length > 0) {
                setCurrentBtnData(prevData => prevData || data[0]);
            }
        }
        setLoading(false);
    };
    const fetchDomainList = async () => {
        const siteList = await siteApi.getSiteDomainList({ isShowOuterSite: false });
        if (!siteList || siteList.length == 0)
            return;
        setCascaderOptions(siteList.map((siteItem) => {
            var _a;
            return ({
                value: siteItem.siteId,
                label: siteItem.siteName,
                children: ((_a = siteItem.bindDomains) === null || _a === void 0 ? void 0 : _a.length) > 1
                    ? siteItem.bindDomains.map(d => ({
                        value: d,
                        label: d,
                    }))
                    : [],
            });
        }));
        if (siteList.length === 1 && siteList[0].bindDomains.length <= 1)
            setSelectSite([siteList[0].siteId]);
    };
    useEffect(() => {
        fetchBtnList();
        fetchDomainList();
    }, []);
    const fetchLandingPageList = async () => {
        if (btnType != 2)
            return;
        const data = await siteApi.getLandingPageByStatus({ status: 'ONLINE' });
        if (Array.isArray(data)) {
            setLandingPageOptions(data.map(item => ({
                value: item.pageId,
                label: item.pageName,
            })));
        }
    };
    useEffect(() => {
        fetchLandingPageList();
    }, [btnType]);
    const handleAddBtn = async () => {
        if (!addBtnName || !addBtnName.trim()) {
            message.error('请输入按钮名称');
            return;
        }
        const data = await siteApi.edmSiteOptAddBtn({ btnName: addBtnName.trim() });
        if (Array.isArray(data)) {
            setBtnList(data);
            if (data.length > 0) {
                setCurrentBtnData(data[data.length - 1]);
            }
        }
        setEditing(false);
    };
    const handleDeleteBtn = (btnId) => {
        Modal.warning({
            title: '确定要删除吗？',
            content: '按钮信息将被删除',
            onOk: async () => {
                const data = (await siteApi.edmSiteOptDeleteBtn({ btnId })) || [];
                setBtnList(data);
                if ((currentBtnData === null || currentBtnData === void 0 ? void 0 : currentBtnData.id) == btnId) {
                    setCurrentBtnData(data[0]);
                }
            },
        });
    };
    const handleSelectProducts = (list) => {
        setShowSettingProductModal(false);
        setSelectProductList(list);
        trackApi.track('mail_interact_insert', { from_page: fromPage, action: 'product' });
    };
    const refreshShowSelectProductCount = () => {
        var _a;
        if (selectProductList.length <= 1) {
            setShowSelectProductCount(false);
            return;
        }
        const contentWidth = (_a = productNameListRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth;
        setShowSelectProductCount(contentWidth > 320);
    };
    useLayoutEffect(() => {
        refreshShowSelectProductCount();
    }, [selectProductList]);
    const goToAddLandingPage = (e) => {
        e.stopPropagation();
        const isElectron = systemApi.isElectron();
        if (isElectron) {
            const jzHost = config('jzHost');
            systemApi.openWaimaoUrlWithLoginInfo(`${jzHost}/#site?page=market&openCreateMarket=true`, true);
        }
        else {
            window.open('/#site?page=market&openCreateMarket=true', '_blank');
        }
    };
    const goFeedBack = () => {
        const isProd = config('stage') === 'prod';
        const url = isProd ? 'https://site.ntesmail.com/feedback.html' : 'https://sirius-it-site.cowork.netease.com/feedback.html';
        window.open(url, '_blank');
    };
    const onLandingPageDropdownVisibleChange = (visible) => {
        if (visible) {
            fetchLandingPageList();
        }
    };
    const onCancel = () => {
        props.onClose();
        trackApi.track('mail_interact_insert', { from_page: fromPage, action: 'cancel' });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { title: modalTitle, visible: props.visible, onCancel: onCancel, onOk: onOk, okButtonProps: {
                disabled: editing || submitLoading,
            }, cancelButtonProps: {
                disabled: editing,
            }, getContainer: props.getContainer, maskClosable: false, className: style.linkButtonModal, width: simpleStyle ? 480 : 580, bodyStyle: { padding: '16px 24px 0' } },
            simpleStyle ? null : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: style.linkButtonModalTitle },
                    React.createElement("span", null, "\u9009\u62E9\u6309\u94AE"),
                    btnList.length < 10 ? (React.createElement("div", { className: classnames(style.linkButtonModalTitleAddBtn, {
                            [style.linkButtonModalTitleAddBtnDisable]: editing,
                        }), onClick: () => {
                            setEditing(true);
                            setAddBtnName('');
                        } },
                        React.createElement(AddIcon, null),
                        "\u65B0\u589E\u6309\u94AE")) : null),
                React.createElement("div", { className: style.btnList, ref: btnListRef },
                    !loading && btnList.length == 0 && !editing ? (React.createElement(Empty, { description: getIn18Text('ZANWUSHUJU'), image: Empty.PRESENTED_IMAGE_SIMPLE, style: { margin: '10px 0 0', fontSize: '12px', color: '#9FA2AD' }, imageStyle: { height: '32px', marginBottom: '4px' } })) : null,
                    btnList.map(btn => (React.createElement("div", { className: classnames(style.btnItem, {
                            [style.btnItemSelected]: !editing && btn.id == (currentBtnData === null || currentBtnData === void 0 ? void 0 : currentBtnData.id),
                        }), onClick: () => setCurrentBtnData(btn) },
                        React.createElement("div", { className: style.btnItemName }, btn.btnName),
                        React.createElement(TongyongGuanbiMian, { stroke: "#8D92A1", onClick: (e) => {
                                e.stopPropagation();
                                handleDeleteBtn(btn.id);
                            } })))),
                    editing && (React.createElement("div", { className: style.btnAddInput },
                        React.createElement(Input, { value: addBtnName, onChange: e => setAddBtnName(e.target.value), placeholder: "\u8BF7\u8F93\u5165", size: "small", style: { width: 200 }, maxLength: 50, onPressEnter: handleAddBtn, autoFocus: true }),
                        React.createElement(CheckIcon, { onClick: handleAddBtn }),
                        React.createElement(CloseIcon, { onClick: () => setEditing(false) })))),
                React.createElement("div", { className: style.linkButtonModalTitle }, "\u8BBE\u7F6E\u6309\u94AE\u8DF3\u8F6C"),
                React.createElement(Radio.Group, { value: btnType, onChange: e => handleBtnTypeChange(e.target.value) },
                    React.createElement(Radio, { value: 1 }, "\u8DF3\u8F6C\u81F3\u5546\u54C1\u5408\u96C6\u9875\u9762"),
                    React.createElement(Radio, { value: 2 }, "\u8DF3\u8F6C\u81F3\u8425\u9500\u843D\u5730\u9875"),
                    React.createElement(Radio, { value: 3 }, "\u8DF3\u8F6C\u81F3\u7ED3\u679C\u53CD\u9988\u9875")))),
            React.createElement("div", { className: classnames(style.optionBlock, { [style.simple]: simpleStyle }) },
                btnType == 1 ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: style.optionBlockRow },
                        React.createElement("div", { className: style.optionBlockRowLabel }, "\u5C55\u793A\u5546\u54C1"),
                        React.createElement(EnhanceSelect, { placeholder: "\u8BF7\u9009\u62E9\u5546\u54C1", onClick: () => setShowSettingProductModal(true), open: false, value: selectProductList.length > 0 ? (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                                React.createElement("div", { className: style.productNameList, ref: productNameListRef }, selectProductList.map(item => item.product_name_cn).join('，')),
                                showSelectProductCount ? React.createElement("span", null,
                                    "\u7B49",
                                    selectProductList.length,
                                    "\u4EF6\u5546\u54C1") : null)) : null })),
                    cascaderOptions.length > 0 ? (React.createElement("div", { className: style.optionBlockRow },
                        React.createElement("div", { className: style.optionBlockRowLabel },
                            "\u6240\u5C5E\u7AD9\u70B9",
                            React.createElement(Tooltip, { title: "\u5546\u54C1\u8BE6\u60C5\u9875\u5C55\u793A\u6837\u5F0F\u5C06\u4EE5\u6240\u9009\u7AD9\u70B9\u5176\u5546\u54C1\u8BE6\u60C5\u9875\u8BBE\u7F6E\u4E3A\u51C6" },
                                React.createElement(TongyongShuomingXian, null))),
                        React.createElement(Cascader, { placeholder: getIn18Text('QINGXUANZE'), options: cascaderOptions, className: `${isSelectSite ? '' : style.siteCascaderError}`, changeOnSelect: true, value: selectSite[0] === '' ? undefined : selectSite, onChange: (value) => {
                                setSelectSite(value);
                                setIsSelectSite(true);
                            }, popupClassName: style.siteCascader }))) : null)) : null,
                btnType == 2 ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: style.optionBlockRow },
                        React.createElement("div", { className: style.optionBlockRowLabel }, "\u9009\u62E9\u8425\u9500\u843D\u5730\u9875"),
                        React.createElement(EnhanceSelect, { placeholder: "\u8BF7\u9009\u62E9", value: selectLandingPage, onDropdownVisibleChange: onLandingPageDropdownVisibleChange, onChange: value => {
                                setSelectLandingPage(value);
                                trackApi.track('mail_interact_insert', { from_page: fromPage, action: 'market_landing' });
                            }, dropdownClassName: style.siteSelect },
                            React.createElement(InSingleOption, { value: "", disabled: true },
                                React.createElement("div", { className: style.optionBlockAddOption, onClick: goToAddLandingPage },
                                    React.createElement(AddIcon, null),
                                    " \u6DFB\u52A0\u8425\u9500\u843D\u5730\u9875")),
                            landingPageOptions.map(item => (React.createElement(InSingleOption, { value: item.value }, item.label))))))) : null,
                btnType == 3 ? React.createElement("a", { onClick: goFeedBack }, "\u67E5\u770B\u7ED3\u679C\u53CD\u9988\u9875\u9762") : null)),
        props.visible ? (React.createElement(ProductSettingModal, { fromPage: "BUTTON", getContainer: props.getContainer, visible: showSettingProductModal, onShow: () => setShowSettingProductModal(true), onAdd: () => { }, onNextStep: handleSelectProducts, onClose: () => setShowSettingProductModal(false) })) : null));
};
export default SiteLinkButtonModal;
